import axios from 'axios';

import { IRequestConfig, IRequestParams, ITcoLocations } from 'types';
import { paramsSerializer } from 'utils/format/paramSerializer';
import { env } from './env';
import { throwQueryError } from './throwQueryError';

interface ILocationRequestParams extends IRequestParams {
  id?: string;
  estimateId?: string;
}

export interface ITcoLocationRequest
  extends IRequestConfig<ITcoLocations | Partial<ITcoLocations>[] | string[]> {
  params?: ILocationRequestParams;
}

export const tcoLocationRequest = async (
  config?: ITcoLocationRequest
): Promise<ITcoLocations | Partial<ITcoLocations>[] | string[]> => {
  const {
    endpoint = 'tco-locations',
    method = 'GET',
    data,
    params,
  } = config || {};

  if (params?.estimateId && !params.id) {
    params.id = params.estimateId;
  }

  const url = `${env.apiUrl}/${endpoint}`;

  return axios({
    url,
    method,
    params,
    paramsSerializer,
    data,
  })
    .then(
      (res) =>
        res.data.data as ITcoLocations | Partial<ITcoLocations>[] | string[]
    )
    .catch((error) =>
      throwQueryError({
        error,
        message: `Something went wrong with location ${method}`,
      })
    );
};
